export const IN_PROGRESS_FNOL_STATUS = 'FNOL_IN_PROGRESS';
export const COMPLETED_FNOL_STATUS = 'FNOL_COMPLETED';
export const CONFIRMED_TOTAL_LOSS_STATUS = 'CONFIRMED';
export const DENIED_TOTAL_LOSS_STATUS = 'DENIED';

export const REDACTED_FROM_VIEWER = 'redacted-from-viewer';
export const PRIVATE_REDACTED = 'private-redacted';
